import { VendorRentalPaymentPrintPage } from "@/features/vendor-consignment-rental-payment/pages/VendorRentalPaymentPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/vendor-rental-approval/$id/print")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: VendorRentalPaymentPrintPage,
});
